'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { SalesInfo } from '@/screens/SaleInfo'

import { TPromotion } from '@/entities/sales'

import { TPage, TPromotionCategories, TPromotionProducts } from '@/shared/types/deprecated-types'

type Props = {
	promotion: TPromotion
	categories: TPromotionCategories
	promotionProducts: TPromotionProducts
	breadcrumbs: TPage[]
	initialCategory: string
	initialOrder: string
	initialLimit: string
}

const SalePageContent = ({
	promotion,
	promotionProducts,
	categories,
	initialCategory,
	initialOrder,
	initialLimit
}: Omit<Props, 'breadcrumbs'>) => {
	const { LAST_PAGE, CURRENT_PAGE, TOTAL, ITEMS } = promotionProducts

	return (
		<>
			<SalesInfo
				{...promotion}
				categories={categories}
				promotionsItems={ITEMS}
				lastPage={LAST_PAGE}
				currentPage={CURRENT_PAGE}
				total={TOTAL}
				initialCategory={initialCategory}
				initialOrder={initialOrder}
				initialLimit={initialLimit}
			/>
		</>
	)
}

export function SaleClient({
	promotion,
	promotionProducts,
	categories,
	breadcrumbs,
	initialCategory,
	initialOrder,
	initialLimit
}: Props) {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<SalePageContent
				promotion={promotion}
				promotionProducts={promotionProducts}
				categories={categories}
				initialCategory={initialCategory}
				initialOrder={initialOrder}
				initialLimit={initialLimit}
			/>
		</>
	)
}
